<div class="">
  <div class="text-center mt-32">
    <div class="font-syne text-3xl font-semibold leading-9 mb-10">
      {{ label }}
    </div>

    <input
      [ngClass]="{ 'border-red-500': errorInRegOrVinNumber }"
      [disabled]="loadingRegOrVinNumber || loadingButton"
      *ngIf="!loadingRegOrVinNumber"
      [(ngModel)]="regOrVinNumber"
      (ngModelChange)="regOrVinNumberChange()"
      (keydown.enter)="dmrInfo()"
      type="text"
      class="my-10 uppercase font-inter py-3 px-4 block w-full border-0 border-b border-gray-200 placeholder-gray-300 text-center text-lg focus:border-gray-200 focus:ring-0"
      [placeholder]="regOrVinNumberInputFocused ? '' : placeholderText"
      (focus)="regOrVinNumberInputFocused = true"
      (blur)="regOrVinNumberInputFocused = false"
    />

    <div *ngIf="specialCarError" class="font-syne my-10">
      <p class="font-semibold">{{ vehicleFromDmr.make }}</p>
      <p class="text-gray-500 text-sm">
        Det indtastede køretøj anses for at være en specialbil.
      </p>
      <p class="text-gray-500 text-sm">
        Kontakt os på support&#64;asgcare.dk for en pris.
      </p>
    </div>

    <div
      *ngIf="loadingRegOrVinNumber && !receivedDMRVehicle"
      class="flex flex-col items-center justify-center"
    >
      <div>
        <lib-loading-indicator size="10"></lib-loading-indicator>
      </div>
      <div>
        <div
          class="text-base font-medium leading-[24px] tracking-tight text-center mt-2"
        >
          Finder bil...
        </div>
      </div>
    </div>

    <div *ngIf="!loadingRegOrVinNumber && receivedDMRVehicle">
      <p class="text-3xl font-syne">
        {{ vehicleFromDmr.make }}
        {{ vehicleFromDmr.model }}
      </p>

      <button
        (click)="dmrScrape()"
        type="button"
        class="py-1 px-4 inline-flex items-center gap-x-2 text-xs font-semibold rounded-lg border border-transparent text-teal-500 hover:text-teal-600 disabled:opacity-50 disabled:pointer-events-none"
      >
        Ikke korrekt? Tryk her
      </button>
    </div>

    <button
      *ngIf="!loadingRegOrVinNumber && !receivedDMRVehicle"
      (click)="dmrInfo()"
      (enter)="dmrInfo()"
      type="button"
      class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-[#34C0A7] text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
    >
      Find bil
    </button>
    <!-- [autofocus]="start.focus()"-->
    <button
      *ngIf="!loadingRegOrVinNumber && receivedDMRVehicle && !loadingButton"
      (click)="nextStep()"
      type="button"
      class="py-3 px-4 focus:outline-none shadow-lg m-10 font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-[#34C0A7] text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
    >
      Start
    </button>

    <div
      *ngIf="!loadingRegOrVinNumber && receivedDMRVehicle && loadingButton"
      class="flex justify-center m-6"
    >
      <lib-loading-indicator size="10"></lib-loading-indicator>
    </div>
  </div>
</div>
